var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info-circle_2_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0071B9;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.194,46.115v25.118h-8V46.115c0-2.209,1.791-4,4-4S52.194,43.906,52.194,46.115z M48.249,25.13 c-3.314-0.024-6.019,2.643-6.043,5.956c-0.024,3.314,2.643,6.019,5.956,6.043c3.314,0.024,6.019-2.643,6.043-5.956 C54.229,27.86,51.562,25.154,48.249,25.13z M93.545,48.138c0,25.264-20.554,45.819-45.818,45.819 c-25.264,0-45.818-20.555-45.818-45.819S22.462,2.32,47.727,2.32C72.991,2.32,93.545,22.874,93.545,48.138z M85.908,48.138 c0-21.054-17.128-38.182-38.182-38.182S9.545,27.084,9.545,48.138c0,21.054,17.128,38.182,38.182,38.182 S85.908,69.192,85.908,48.138z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.36922d87b21720f481eaa3fff8b013a0.svg";
export { ForwardRef as ReactComponent };